import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Awareness from "./sections/Awareness";
import Impact from "./sections/Impact";
import Mission from "./sections/Mission";
import Process from "./sections/Process";
import FeaturedCauses from "./sections/FeaturedCauses";
import Movement from "./sections/Movement";
import Support from "./sections/Support";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      
      <Awareness />
      <Impact />
      <Mission />
      <Process />
      <FeaturedCauses />
      <Movement />
      
      <Footer />
    </div>;
}